export default [{
    path: 'violationManage',
    name: 'violationManage',
    meta: {
        title: '违规管理'
    },
    component: resolve => {
        require(['@/views/violationManage/index'], resolve)
    },
}, {
    path: 'violationDetail',
    name: 'violationDetail',
    meta: {
        title: '违规明细'
    },
    component: resolve => {
        require(['@/views/violationManage/violationDetail'], resolve)
    },
}]